<template>
  <div>
    <slot name="banner" />
    <!-- start page title -->
    <div :class="['w-100', { 'mb-4': !isSticky, 'sticky-header': isSticky }, 'banner-header']">
      <McBreadcrumb
        v-if="hasBreadcrumb"
        :items="items"
        :routeBack="routeBack"
        :pageType="pageType"
        class="mb-4"
        :hasBackButton="hasBackButton"
        :buttonText="buttonText"
      />

      <div class="row">
        <div class="col-12 d-flex justify-content-between align-items-center">
          <div class="d-flex">
            <slot name="beforeTitle"></slot>
            <slot v-if="customTitle" name="title" class="mc-page-title"></slot>
            <h4 v-else class="mc-page-title">{{ title }}</h4>

            <slot name="besideTitle"></slot>
          </div>

          <slot name="afterTitle"></slot>
        </div>
        <div v-if="subTitle" class="mc-sub-title col-12 d-flex align-items-center">
          {{ subTitle }}
        </div>
      </div>

      <slot name="footer" />
    </div>
  </div>
  <!-- end page title -->
</template>

<script>
import McBreadcrumb from '@/components/McBreadcrumb'

export default {
  components: {
    McBreadcrumb,
  },
  slots: ['afterTitle'],
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
    pageType: {
      type: String,
      default: '',
    },
    hasBreadcrumb: {
      type: Boolean,
      default: false,
    },
    hasBackButton: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '',
    },
    routeBack: {
      type: String,
    },
    isSticky: {
      type: Boolean,
      default: false,
    },
    customTitle: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleBackButton() {
      if (this.routeBack) {
        return this.$router
          .push({
            path: this.routeBack,
          })
          .catch(() => {})
      }

      return this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-page-title {
  font-size: 20px;
  font-weight: 600;
  color: $mep-color-text;
}

.mc-sub-title {
  color: $mep-color-text-400;
}

.sticky-header {
  padding: 12px 20px;
}

.mc-custom-page-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mc-custom-page-title p {
  font-size: 14px;
  font-weight: 400;
  margin: 0;
  color: #666666;
  line-height: 1.4;
}

.mc-custom-page-title {
  padding: 8px 0;
}
</style>
